module.exports = __webpack_public_path__ + "assets/img/openinvest-get-started-w960.03349ab1.jpg";